import React from 'react'
import { connect } from 'react-redux'

import { NavigationMenuKey, RouteKey } from '@store/constants'
import { ProjectIdentity, RootStateTypeExtra } from '@store/types'

import FirebaseControlQuery from '@firebaseUtil/firebase-control-query'

import { ProjectType } from '@adUtilities/constants/common'

interface EmptyStateProps {
  projectIdentity: ProjectIdentity
}

function EmptyState({ projectIdentity }: EmptyStateProps) {
  const firebaseControlQuery = FirebaseControlQuery({
    ...projectIdentity,
    sessionKey: projectIdentity.sessionId,
  })

  const {
    isSnaploaderActive: hasSnaploader,
    isEnvisionVRActive: hasEnvisionVR,
    showcase3DIntegration,
    type,
  } = projectIdentity

  const handleNavigateToResidences = () => {
    if (showcase3DIntegration) {
      firebaseControlQuery.updateRoute(RouteKey.ADTHREED)
      return
    }

    if (type === ProjectType.HouseAndLand) {
      firebaseControlQuery.updateRoute(RouteKey.AREA_VIEW_HOUSE_AND_LAND)
      return
    }

    if (hasSnaploader) {
      firebaseControlQuery.updateRoute(RouteKey.SNAPLOADER_VIEW)
      return
    }

    if (hasEnvisionVR) {
      firebaseControlQuery.updateRoute(RouteKey.THREE_D_BUILDING)
      return
    }

    firebaseControlQuery.updateRoute(RouteKey.AREA_VIEW)
  }

  const exploreLinkText = React.useMemo(() => {
    const dynamicResidencesText = projectIdentity?.navigationSettings?.find(
      (item) => item.key === NavigationMenuKey.RESIDENCES
    )
    if (dynamicResidencesText && dynamicResidencesText.label) {
      return `Explore ${dynamicResidencesText.label?.toLowerCase()}`
    }
    if (projectIdentity?.type === ProjectType.HouseAndLand) {
      return 'Explore Precinct'
    }
    return 'Explore Residences'
  }, [projectIdentity?.navigationSettings, projectIdentity?.type])

  return (
    <div className="flex w-full flex-col items-center justify-center rounded-lg bg-neutralColour p-6">
      <p className="mb-6 text-heading font-medium">Your Shortlist is empty</p>
      <p className="mb-11 text-default">Add your favourite properties in it.</p>
      <button
        type="button"
        className="rounded-xl bg-gradient px-12 py-4 text-subHeading font-medium capitalize text-white shadow-standard"
        onClick={handleNavigateToResidences}
      >
        {exploreLinkText}
      </button>
    </div>
  )
}

export default connect(({ projectIdentity }: RootStateTypeExtra) => ({
  projectIdentity,
}))(EmptyState)
